<mat-card class="welcome-card">
  <mat-card-header class="d-flex justify-content-center animate-slide-up delay-1">
    <img
      src="/assets/icons/avyna/logo.svg"
      [alt]="'onboarding.shared.logoAlt' | translate"
      class="avyna-logo pb-3"
    />
  </mat-card-header>

  <mat-card-content class="text-center">
    <div class="mb-4">
      <h1 class="fs-2 fw-bold title-text mb-3 animate-slide-up delay-2">
        {{ 'onboarding.auth.login.title' | translate }}
      </h1>

      <p class="fs-6 subtitle-text animate-slide-up delay-2">
        {{ 'onboarding.auth.login.subtitleLine1' | translate }}<br />
        {{ 'onboarding.auth.login.subtitleLine2' | translate }}
      </p>
    </div>

    <button
      mat-flat-button
      class="w-100 microsoft-btn animate-slide-up delay-3"
      (click)="loginWithMicrosoft()"
      [disabled]="isLoading()"
    >
      @if (isLoading()) {
        <mat-spinner diameter="20" color="accent" class="d-inline-block me-2"></mat-spinner>
        <span>{{ 'onboarding.auth.login.connecting' | translate }}</span>
      } @else {
        <img
          src="/assets/icons/microsoft_icon.svg"
          [alt]="'onboarding.shared.microsoftAlt' | translate"
          class="d-inline-block me-2 microsoft-icon"
        />
        <span>{{ 'onboarding.auth.login.signIn' | translate }}</span>
      }
    </button>

    <div
      class="d-flex align-items-center justify-content-center security-hint small gap-2 pt-3 animate-slide-up delay-4"
    >
      <mat-icon>security</mat-icon>
      <span>{{ 'onboarding.auth.login.secureHint' | translate }}</span>
    </div>
  </mat-card-content>
</mat-card>
